import React from "react";


import BottomSectionComponent from "../Sections/BottomSection";
import AppSupportSectionButtons from "./Buttons";


import "./index.scss";
import {UseQyvoUser} from "@Store/@Hooks";


export const SupportSectionComponent: React.FC = () => {


    return (
        <BottomSectionComponent
            sectionName={'app-support-section'}
            sectionHeaderText={'Still have questions?'}
            sectionSubText={'Get in touch with our team for personalized answers'}
        >
            <AppSupportSectionButtons />
        </BottomSectionComponent>
    );

};


export default SupportSectionComponent;
